module.exports = __webpack_public_path__ + "img/selo_inbetta.03652d2d.png";